<template>
  <div id="">
    <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      status-icon
      :rules="rules"
      label-width="140px"
      class="demo-ruleForm"
      v-loading="isLoading"
    >
      <el-form-item label="广告图名称" prop="name">
        <el-input
          v-model="ruleForm.name"
          placeholder="请输入广告图名称"
          clearable
           size="large"
        ></el-input>
      </el-form-item>
      <el-form-item label="广告图" prop="url">
        <ImgUpload
          v-if="isChild"
          :type="3"
          :limit="1"
          ref="addEditImgRef"
          :imagePath="ruleForm.url"
          @change-image="changeImage"
        ></ImgUpload>
      </el-form-item>
      <el-form-item label="跳转URL" prop="link">
        <el-input
          type="mapAddress"
          v-model="ruleForm.link"
          placeholder="请输入跳转URL"
          clearable
           size="large"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="广告图投放位置"
        class="item"
        prop="bannerPositionClass"
      >
        <el-select
          v-model="ruleForm.bannerPositionClass"
          placeholder="请选择广告图投放位置"
           size="large"
        >
          <el-option
            v-for="item in showPositionType"
            :key="item.key"
            :label="item.value"
            :value="item.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否新窗口打开" prop="isOtherOpen">
        <el-switch
          v-model="ruleForm.isOtherOpen"
          active-text="是"
           size="large"
          inactive-text="否"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="备注说明" prop="remarks">
        <el-input
          v-model="ruleForm.remarks"
          :rows="2"
           size="large"
          type="textarea"
          placeholder="请输入备注"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="from_btn">
      <!-- <el-button size="large" @click="resetForm(ruleFormRef)">重置</el-button> -->
      <el-button size="large" @click="onCancel">取消</el-button>
        <el-button size="large" v-if="!submitDisabled" type="primary" @click="submitForm(ruleFormRef)"
          :disabled = "submitDisabled">提交保存</el-button
        >
        <el-button type="primary" size="large" loading v-else>提交中</el-button>
    </div>
  </div>
</template>

<script>
import ImgUpload from "components/ImgUpload";
import { Add, Edit } from "../../network/advertisingImages";
import { toRefs, reactive, ref, unref, onMounted, watch, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  components: {
    ImgUpload,
  },
  props: {
    editTarget: Number,
    showPositionType: Array,
    EditInfo: {
      type: Object,
      default: () => {},
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    var validatorUrl = (rule, value, callback) => {
      if (data.ruleForm.url == "") {
        callback(new Error("请选择广告图"));
      } else {
        callback();
      }
    };
    var validatorlink = (rule, value, callback) => {
      if (data.ruleForm.link == "") {
        callback(new Error("请输入跳转链接"));
      } else {
        var strRegex = /^(http(s?)|):\/\//;
        var regex = new RegExp(strRegex);
        if (regex.test(value)) {
          callback();
        } else {
          callback(new Error("链接必须以http://或者https://开头"));
        }
      }
    };
    const data = reactive({
      isLoading: false,
      ruleForm: {
        name: "",
        url: "",
        link: "",
        isOtherOpen: true,
        bannerPositionClass: null,
        remarks: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入广告图名称",
            trigger: ["blur", "change"],
          },
        ],
        url: [
          {
            required: true,
            validator: validatorUrl,
            trigger: ["blur", "change"],
          },
        ],
        link: [
          {
            required: true,
            validator: validatorlink,
            trigger: ["blur", "change"],
          },
        ],
        bannerPositionClass: [
          {
            required: true,
            message: "请选择广告图投放位置",
            trigger: ["blur", "change"],
          },
        ],
      },
      isChild: false,
      submitDisabled:false
    });

    onMounted(() => {
      //编辑-获取详情
      if (props.isEdit) {
        data.ruleForm = JSON.parse(JSON.stringify(props.EditInfo));
        data.isChild = true;
      } else {
        data.isChild = true;
      }
    });

    const addEditImgRef = ref();

    //获取图片上传组件传过来的
    const changeImage = (arr) => {
      if (arr && arr.length > 0) {
        data.ruleForm.url = arr[0].url;
        ruleFormRef.value.clearValidate("url");
      } else {
        data.ruleForm.url = "";
      }
    };
    // 提交
    const ruleFormRef = ref();
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled=true;
          submitPost().then(() => {
            data.submitDisabled = false;
          });;
        }
      } catch (error) {
        ElMessage.error("有必填内容未填写！");
        console.log(error);
      }
    };
    const submitPost = async () => {
      var res;
      if (props.isEdit) {
        data.ruleForm.id = props.EditInfo.id;
        res = await Edit(data.ruleForm);
      } else {
        res = await Add(data.ruleForm);
      }
      if (res && res.code == 1) {
        data.isLoading = false;
        ElMessageBox.alert(res.message, props.isEdit ? "编辑" : "添加", {
          confirmButtonText: "确定",
        });
        if (addEditImgRef.value) {
            addEditImgRef.value.submitData(data.ruleForm.url);
          }
        emit("close-dialog");
        emit("update-list");
      } else {
        data.isLoading = false;
        ElMessageBox.alert(res.message, {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    };
    // 取消
    const onCancel = () => {
      emit("close-dialog");
      if (addEditImgRef.value) {
        addEditImgRef.value.cancelData();
      }
    };
    // 重置
    const resetForm = () => {
      if (ruleFormRef.value) {
        ruleFormRef.value.resetFields();
      }
      if (addEditImgRef.value) {
        // addEditImgRef.value.clearFiles();
        addEditImgRef.value.fileList=[];
      }
      data.ruleForm = {
        name: "",
        url: "",
        link: "",
        isOtherOpen: true,
        bannerPositionClass: null,
        remarks: "",
      };
    };
    return {
      ...toRefs(data),
      changeImage,
      submitForm,
      ruleFormRef,
      addEditImgRef,
      onCancel,
      resetForm,
    };
  },
};
</script>

<style scoped>
.btn-area {
  position: absolute;
  bottom: 30px;
  left: 160px;
}
.item >>> .el-input__inner {
  width: 350px;
}
</style>